import Cookies from 'js-cookie';
import React, { createContext, useEffect, useState } from 'react'

const JOB_URL = 'https://dev-example.sanbercloud.com/api/job-vacancy';
const LOGIN_URL = 'https://dev-example.sanbercloud.com/api/login';
const REGIS_URL = 'https://dev-example.sanbercloud.com/api/register';

export const DataContext = createContext();

export const DataProvider = ({children}) => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [token, setToken] = useState(null); // menyimpan token, jadi ga usah pake localstorage / cookies
  // const [userRole, setUserRole] = useState(null)

  const fetchData = async () => {
    try {
      // Simulate a delay of 30 seconds (30000 milliseconds)
      await new Promise(resolve => setTimeout(resolve, 30000));

      const response = await fetch(JOB_URL);
      const result = await response.json();

      // console.log(result);

      setData(result);
      setLoading(false); // Set loading to false once data is fetched

    } catch (error) {
      console.log('get data gagal')
      setLoading(false); // Set loading to false in case of an error
    }
  }

  const login = async (email, password, role) => {
    try {
      const response = await fetch(LOGIN_URL, {
        method: 'POST',
        headers: {
          'Content-Type' : 'application/json',
         },
        body: JSON.stringify({email, password}),
      })

      if (!response.ok) {
        throw new Error('Login gagal');
      }

      const result = await response.json();
      // console.log(result)

      const userToken = result.token;

      // console.log(userToken)

      Cookies.set('userToken', userToken, {expires: 1})

      // setToken(userToken);

      // Lakukan sesuatu dengan token, jika diperlukan
      if (userToken) {
        // Determine user role based on your application's logic
        const determinedRole = role === 'admin' ? 'admin' : 'member';

        // setUserRole(determinedRole);
        Cookies.set('userRole', determinedRole, {expires: 1})
      }



      return userToken;
    } catch (error) {
      console.error('Login gagal:', error);
      throw error;
    }
  }

  const register = async (name, imageUrl, email, password) => {
    try {
      const response = await fetch(REGIS_URL, {
        method: 'POST',
        headers: {
          'Content-Type' : 'application/json',
        },
        body: JSON.stringify({name, image_url: imageUrl, email, password})
      });

      if (!response.ok) {
        throw new Error ('Register GAGAL')
      }

      const result = await response.json();
    console.log(result);

    // If needed, you can handle the result or set state accordingly

    return result; // You might want to return something specific based on the API response

    } catch (error) {
      console.error('Registration failed:', error);
      throw error;
    }
  }

 // Memastikan bahwa data diambil saat komponen di-mount
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <DataContext.Provider value={{data, loading, login, register}}>
      {children}
    </DataContext.Provider>
  )
}
